import { styled, SxProps, Table, TableBody, TableCell, TableRow, Theme } from "@mui/material";
import TableHeader from "./TableHeader";
import { Property } from "csstype";
import { sizing } from "../../utils/methods";
import { CSSProperties } from "react";

export type TableSchema<T> = {
  id: string;
  label: string;
  align?: Property.TextAlign;
  render?: (data: T, i?: number) => any;
  style?: CSSProperties;
  sx?: SxProps<Theme>;
  headerStyle?: SxProps<Theme>;
  skeleton?: () => any;
};

type TableViewProps = {
  data: any[];
  schema: TableSchema<any>[];
  pendingState?: boolean;
  pagination?: boolean;
  loading?: boolean;
  error?: boolean;
  hidePaginationLimit?: number;
};

const TableView = ({ schema, data, loading, error }: TableViewProps) => {
  return (
    <>
      <Table>
        <TableHeader schema={schema} />
        {data.length > 0 && !error && (
          <TableBody>
            {data.map((model, m_index) => {
              return (
                <TableRow key={m_index}>
                  {schema.map((column, c_index) => (
                    <Cell
                      style={column.style}
                      sx={{ p: sizing(6), paddingLeft: sizing(0), ...column.sx }}
                      key={c_index}
                    >
                      {column.render ? column.render(model, m_index) : model[column.id]}
                    </Cell>
                  ))}
                </TableRow>
              );
            })}
          </TableBody>
        )}
      </Table>
      {data.length === 0 && !loading && !error && <NoData sx={{ paddingY: sizing(6) }}>No data</NoData>}
      {error && <NoData sx={{ paddingY: sizing(6), color: "error.main" }}>Failed to load data</NoData>}
      {loading && <NoData sx={{ paddingY: sizing(6) }}>Data is loading...</NoData>}
    </>
  );
};

const Cell = styled(TableCell)`
  vertical-align: top;
  font-size: 16px;
  white-space: nowrap;
  @media (max-width: 560px) {
    font-size: 14px;
  }
  & > div,
  & > span {
    min-width: -webkit-max-content;
    min-width: max-content;
    white-space: nowrap;
  }
`;

const NoData = styled("div")`
  color: ${({ theme }) => theme.palette.text.disabled};
  width: 100%;
  display: flex;
  align-items: center;
  height: 56px;
  border-bottom: var(--border);
  border-color: ${({ theme }) => theme.palette.border.dark};
`;

export default TableView;
